import { useEffect, useState } from "react";
import Input from "src/components/Form/Input/Input";
import useDebounce from "src/hooks/useDebounce";
import { ReactComponent as FilterIcon } from "src/assets/svg/filter.svg";
import { ReactComponent as Search } from "src/assets/svg/search.svg";
import { FiltersValue } from "./types";
import FiltersModal from "./FiltersModal";
import useLoader from "src/hooks/useLoader";
import { getJobsPaginated } from "src/network/job";
import Job from "src/types/models/Job";
import { useAppSelector } from "src/redux/store";
import ConstraintModal from "src/components/Modal/ConstraintModal";

interface IFilters {
  value: FiltersValue;
  setValue: (v: FiltersValue) => void;
}

const Filters = ({ value, setValue }: IFilters) => {
  const enabled = useAppSelector(
    (r) => !!r.client.client?.Company.UsageConstraints?.talent_search_enabled
  );
  const [show, setShow] = useState(false);
  // We need them for dropdowns
  const [jobs, setJobs] = useState<Job[]>();
  const { ldng: fetchJobs } = useLoader(async () => {
    const js = (await getJobsPaginated({ attributes: ["id", "job_title"] })).data;
    setJobs(js);
  });

  // Filtering
  const setFilter = (key: keyof FiltersValue, v: any) => {
    setValue({ ...value, [key]: v });
  };
  const debounceSetFilter = useDebounce(setFilter);

  useEffect(() => {
    fetchJobs();
  }, []);

  return (
    <div className="relative flex gap-4">
      <Input
        disabled={!enabled}
        icon={<Search className="w-6 h-6 " />}
        wrapClassName="!w-[400px] "
        placeholder="Search for talent by name, role, skills or more"
        className="!rounded-2xl"
        onChange={(e) => debounceSetFilter("keyword", e.target.value)}
      />
      <button
        type="button"
        className="px-4 py-3 border-[1px] border-odfblue hover:bg-odfblue-hue rounded-2xl flex gap-4 items-center justify-center font-poppins text-sm font-medium "
        onClick={() => setShow(!show)}
      >
        Filters
        <FilterIcon />
      </button>

      <FiltersModal
        jobs={jobs}
        setValue={setValue}
        value={value}
        key={`${show}`}
        open={show && enabled}
        setOpen={setShow}
      />

      <ConstraintModal
        open={show && !enabled}
        onClose={() => setShow(false)}
        variant="talent_search_enabled"
      />
    </div>
  );
};

export default Filters;
